// LIBRERIE/IMPORTS
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import appConfig from "../../config/appConfig";

const BannerVendi: React.FC = () => {
    const { t } = useTranslation();

    return (
        <section className="valutazione space-ptb bg-overlay-black-70">
            <div className="container text-center position-relative py-3">
                <strong className="text-gold mb-3 d-block">{appConfig.agency.name}</strong>
                <div className="row justify-content-center">
                    <div className="col-12 col-lg-10">
                        <h2 className="mb-4 text-white" dangerouslySetInnerHTML={{ __html: t('homePage.sellBanner.title') as string }} />
                        <Link className="btn btn-gold" to="/vendi-casa">
                            <span>{t('homePage.sellBanner.btnText')}</span>
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default BannerVendi;